var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 73.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a7ff9037-a7fd-4f90-be36-64e70322426b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e5f059bf-f26b-4041-9b13-6bcf99d0b2d6",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.15,13.45q9.49,0,16.13,4.32a27.18,27.18,0,0,1,10.1,12.55q3.46,8.24,3.47,19.88,0,11.2-3.73,19.37A28.85,28.85,0,0,1,49.6,82.17,28.75,28.75,0,0,1,33.55,86.6q-9.45,0-16.1-4.33A26.93,26.93,0,0,1,7.33,69.72Q3.85,61.5,3.85,49.85q0-11.25,3.73-19.4A28.88,28.88,0,0,1,18.12,17.87,28.82,28.82,0,0,1,34.15,13.45ZM48,52.1a95.69,95.69,0,0,0-1.65-19.75q-1.65-7.55-4.85-11a10.33,10.33,0,0,0-7.9-3.47,10,10,0,0,0-7.52,3.25Q22.95,24.35,21.3,31A72.28,72.28,0,0,0,19.65,48,94,94,0,0,0,21.33,67.7c1.11,5,2.75,8.7,4.89,11a10.4,10.4,0,0,0,7.88,3.45,10,10,0,0,0,7.52-3.25q3.14-3.25,4.76-9.93A73.19,73.19,0,0,0,48,52.1Z",
    transform: "translate(-3.85 -13.45)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.dcf49ac53f61b5ac67aab88c7c1d2a38.svg";
export { ForwardRef as ReactComponent };